import PlusIcon from "@rsuite/icons/Plus";
import { useContext, useEffect, useState, type FC } from "react";
import { BsTrash3 } from "react-icons/bs";
import { Avatar, AvatarGroup, Checkbox, IconButton, Table } from "rsuite";
import PopularProductForm from "../components/features/inventory/PopularProductForm";
import MainLayout from "../components/MainLayout";
import { LoadingContext } from "../contexts/LoadingContext";
import { PopularProduct } from "../models/inventory/product";
import {
  addPopularProduct,
  deletePopularProduct,
  getPopularProducts,
  updatePopularProduct,
} from "../services/inventory/ProductApi";
import { errorToast } from "../utils/helper-ui";
import { money } from "../utils/helper";
import { FileModel } from "../models/file/file";
const { Column, HeaderCell, Cell } = Table;
interface PopularProductPageProps {}

const PopularProductPage: FC<PopularProductPageProps> = ({}) => {
  const [mounted, setMounted] = useState(false);
  const [popularProduct, setPopularProducts] = useState<PopularProduct[]>([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  const [selected, setSelected] = useState<PopularProduct>();
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === popularProduct.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (checkedKeys.length > 0 && checkedKeys.length < popularProduct.length) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? popularProduct.map((item) => item.id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  const removePopularProduct = async (topBrandId: string) => {
    const confirmRemove = window.confirm(
      `Are you sure to remove top product ${topBrandId}?`
    );
    if (!confirmRemove) return;
    setIsLoading(true);
    try {
      await deletePopularProduct(topBrandId);
      getPopularProducts()
        .then((v) => v.json())
        .then((v) => setPopularProducts(v.data));
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    if (!mounted) return;
    getPopularProducts()
      .then((v) => v.json())
      .then((v) => setPopularProducts(v.data));
  }, [mounted]);

  const addNewPopularProduct = async (data: PopularProduct) => {
    try {
      setIsLoading(true);
      if (selected) {
        await updatePopularProduct(selected.product!.id!, data);
      } else {
        await addPopularProduct(data);
      }
      getPopularProducts()
        .then((v) => v.json())
        .then((response) => {
          setPopularProducts(response.data);
          setModalFormOpen(false);
        });
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Popular Product</h1>
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Add Popular Product
        </IconButton>
      </div>
    </div>
  );
  return (
    <MainLayout header={renderHeader()}>
        <div className="w-full overflow-y-auto">
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th className="px-4 py-2 text-left border bg-gray-50 w-32">
                <Checkbox
                  inline
                  checked={checked}
                  indeterminate={indeterminate}
                  onChange={handleCheckAll}
                />
              </th>
              <th className="px-4 py-2 text-left border bg-gray-50">Name</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Image</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Value</th>
              <th className="px-4 py-2 text-left border bg-gray-50">Action</th>
            </tr>
          </thead>
          <tbody>
            {popularProduct.map((item, i) => (
              <tr key={item.id}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={item.id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some((e) => e === item.id)}
                  />
                  {i + 1}
                </td>

                <td className="px-4 py-2 border">
                  <div
                    className="hover:underline cursor-pointer font-semibold"
                    onClick={() => {
                      setSelected(item);
                      setModalFormOpen(true);
                    }}
                  >
                    {item?.product?.name}
                  </div>
                </td>
                <td className="px-4 py-2 border">
                <div className="flex flex-wrap">
                <AvatarGroup stack>
                  {(item?.product?.product_images ?? [])
                    .filter((p: FileModel, i: number) => i < 5)
                    .map((p: FileModel) => (
                      <Avatar size="xs"
                        bordered
                        circle
                        key={p.id}
                        src={p.url}
                        alt={p.file_name}
                      />
                    ))}
                  {(item?.product?.product_images ?? []).length - 5 > 0 && (
                    <Avatar size="xs" bordered circle style={{ background: "#111" }}>
                      +{(item?.product?.product_images ?? []).length - 5}
                    </Avatar>
                  )}
                </AvatarGroup>
              </div>
                </td>
                <td className="px-4 py-2 border">{money(item.score)}</td>
                <td className="px-4 py-2 border">
                  <BsTrash3
                    className="text-red-500 hover:text-red-800"
                    size={16}
                    onClick={() => removePopularProduct(item.product_id)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
          </table>
          </div>
      {/* <Table minHeight={700} data={popularProduct} onRowClick={(data, i) => {}}>
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(rowData) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={rowData.id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some((item) => item === rowData.id)}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(rowData) => (
              <div>{popularProduct.indexOf(rowData as PopularProduct) + 1}</div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(rowData) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {
                  setSelected(rowData as PopularProduct);
                  setModalFormOpen(true);
                }}
              >
                {rowData.product?.name}
              </div>
            )}
          </Cell>
        </Column>



        <Column width={100} resizable>
          <HeaderCell>Image</HeaderCell>
          <Cell>
            {(rowData) => (
              <div className="flex flex-wrap">
                <AvatarGroup stack>
                  {(rowData?.product.product_images ?? [])
                    .filter((p: FileModel, i: number) => i < 5)
                    .map((p: FileModel) => (
                      <Avatar size="xs"
                        bordered
                        circle
                        key={p.id}
                        src={p.url}
                        alt={p.file_name}
                      />
                    ))}
                  {(rowData?.product.product_images ?? []).length - 5 > 0 && (
                    <Avatar size="xs" bordered circle style={{ background: "#111" }}>
                      +{(rowData?.product.product_images ?? []).length - 5}
                    </Avatar>
                  )}
                </AvatarGroup>
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Value</HeaderCell>
          <Cell >
            {(rowData) => (
              <div>{money(rowData.score)}</div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable>
          <HeaderCell>Action</HeaderCell>
          <Cell>
            {(rowData) => (
              <BsTrash3
                className="text-red-500 hover:text-red-800"
                size={16}
                onClick={() => removePopularProduct(rowData.product_id)}
              />
            )}
          </Cell>
        </Column>
      </Table> */}
      <PopularProductForm
        open={modalFormOpen}
        onClose={() => setModalFormOpen(false)}
        onSubmit={(val) => {
          addNewPopularProduct(val);
        }}
        popularProduct={selected}
      />
    </MainLayout>
  );
};
export default PopularProductPage;

